(function () {
  const grid = document.querySelector('.custom-product-grid');
  const track = document.querySelector('.custom-scrollbar-track');
  const thumb = document.querySelector('.custom-scrollbar-thumb');
  if (!grid || !track || !thumb) return;

  function updateThumb() {
    const { scrollWidth, clientWidth, scrollLeft } = grid;
    if (scrollWidth <= clientWidth) {
      track.style.display = 'none';
      return;
    }
    track.style.display = '';
    const visibleRatio = clientWidth / scrollWidth;
    const trackWidth = track.clientWidth;
    const thumbWidth = Math.max(20, trackWidth * visibleRatio);
    const maxLeft = trackWidth - thumbWidth;
    const left = maxLeft * (scrollLeft / (scrollWidth - clientWidth));
    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${left}px)`;
  }

  // observer grid on viewport
  const observer = new IntersectionObserver(
    (entries, obs) => {
      if (entries[0].isIntersecting) {
        // Bind event when element show
        grid.addEventListener('scroll', updateThumb, { passive: true });
        window.addEventListener('resize', updateThumb);
        updateThumb();

        // Run 1 time, and remove obs
        obs.disconnect();
      }
    },
    { threshold: 0 }
  );

  observer.observe(grid);
})();
